import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import {FC} from "react";
import CircularProgress from "@mui/material/CircularProgress";

type LoadingOverlayProps = {
    opacity: number
}

const Overlay = styled(Box)<LoadingOverlayProps>(({opacity}) => ({
    background: '#bab29eaa',
    transition: 'opacity 0.3s',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    opacity,
}))

const LoadingOverlay: FC<LoadingOverlayProps> = (props) => (
    <Overlay {...props}>
        <CircularProgress/>
    </Overlay>
)

export default LoadingOverlay;
